import { getFetchedDataPayload } from '../../../../utils/fetched-data/get-fetched-data-payload';
import { salesDataDomainStore } from '../../store';
export const getSubscriptionBillingOptionById = (id) => {
    var _a;
    return (_a = getFetchedDataPayload(salesDataDomainStore.data.subscriptionBillingOptionsById)) === null || _a === void 0 ? void 0 : _a[id];
};
